import { setAlert } from '../../alert';

import {
    POST_FLIGHTS_AND_ACCOMMODATION_DATA_SUCCESS,
    POST_FLIGHTS_AND_ACCOMMODATION_DATA_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_DATA_SUCCESS,
    GET_FLIGHTS_AND_ACCOMMODATION_DATA_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS_SUCCESS,
    GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS_FAIL
} from '../types/03-indirect-ghg-emissions-from-transportation';

import {
    API_POST_FLIGHTS_AND_ACCOMMODATION_DATA,
    API_GET_FLIGHTS_AND_ACCOMMODATION_DATA,
    API_GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS
} from '../constants/03-indirect-ghg-emissions-from-transportation';

import api from '../../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json'
    }
};

const formDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};

export const postFlightsAndAccommodationData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_FLIGHTS_AND_ACCOMMODATION_DATA + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_FLIGHTS_AND_ACCOMMODATION_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_FLIGHTS_AND_ACCOMMODATION_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFlightsAndAccommodationData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FLIGHTS_AND_ACCOMMODATION_DATA + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            config
        );
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFlightsAndAccommodationDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS + `/${year}/${facility}`,
            config
        );
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FLIGHTS_AND_ACCOMMODATION_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};